<div class="modal-header d-flex align-items-center p-3">
  <h4 class="modal-title font-size-18">{{ 'AtgContactUs.title' | cxTranslate }}</h4>
  <button type="button" class="close pb-0" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  @if (submitSuccess) {
    <div class="text-center py-4">
      <i class="fas fa-check-circle text-success" style="font-size: 3rem;"></i>
      <p class="mt-3 font-size-16">{{ successMessage }}</p>
    </div>
  }

  @if (!submitSuccess) {
    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
      <div class="form-group row pb-2 p-0">
        <label for="form" class="label-content required col-12 col-md-3 mb-1 mb-md-0">
          {{ 'AtgContactUs.from' | cxTranslate }}<span class="text-danger ml-1">*</span>
        </label>
        <div class="col-12 col-md-9">
          <input id="form" type="text" class="form-control" formControlName="form" />
          @if (f['form'].invalid && f['form'].touched) {
            <div class="text-danger small mt-1">
              {{ 'AtgContactUs.formRequired' | cxTranslate }}
            </div>
          }
        </div>
      </div>
      <div class="form-group row pb-2 p-0">
        <label class="label-content required col-12 col-md-3 mb-1 mb-md-0">
          {{ 'AtgContactUs.reason' | cxTranslate }}<span class="text-danger ml-1">*</span>
        </label>
        <div class="col-12 col-md-9">
          <ng-select [items]="reasonOptions" bindValue="value" bindLabel="label" [clearable]="false" formControlName="reason"
            [placeholder]="'AtgContactUs.reasonPlaceholder' | cxTranslate">
            <ng-template ng-option-tmp let-item="item">{{ item?.label ? (item.label | cxTranslate) : '' }}</ng-template>
            <ng-template ng-label-tmp let-item="item">{{ item?.label ? (item.label | cxTranslate) : '' }}</ng-template>
          </ng-select>
          @if (f['reason'].invalid && f['reason'].touched) {
            <div class="text-danger small mt-1">
              {{ 'AtgContactUs.reasonRequired' | cxTranslate }}
            </div>
          }
        </div>
      </div>
      <div class="form-group row pb-2 p-0">
        <label for="userCountry" class="label-content required col-12 col-md-3 mb-1 mb-md-0">
          {{ 'customer.label.country' | cxTranslate }}<span class="text-danger ml-1">*</span>
        </label>
        <div class="col-12 col-md-9">
          <ng-select [items]="countries$ | async" bindLabel="name" bindValue="isocode" [clearable]="false" [loading]="isCountryLoading"
            formControlName="userCountry" [placeholder]="'AtgContactUs.selectCountry' | cxTranslate">
          </ng-select>
          @if (f['userCountry'].invalid && f['userCountry'].touched) {
            <div class="text-danger small mt-1">
              {{ 'AtgContactUs.countryRequired' | cxTranslate }}
            </div>
          }
        </div>
      </div>
      <div class="form-group row pb-2 p-0">
        <label for="subject" class="label-content required col-12 col-md-3 mb-1 mb-md-0">
          {{ 'AtgContactUs.subject' | cxTranslate }}<span class="text-danger ml-1">*</span>
        </label>
        <div class="col-12 col-md-9">
          <input id="subject" type="text" class="form-control" maxlength="250" formControlName="subject" />
          <div class="d-flex justify-content-between mt-1">
            @if (f['subject'].invalid && f['subject'].touched) {
              <div class="text-danger small">
                {{ 'AtgContactUs.subjectRequired' | cxTranslate }}
              </div>
            }
            <div class="text-muted small text-right">{{ f['subject'].value?.length || 0 }}/250</div>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2 p-0">
        <label for="message" class="label-content required col-12 col-md-3 mb-1 mb-md-0">
          {{ 'AtgContactUs.message' | cxTranslate }}<span class="text-danger ml-1">*</span>
        </label>
        <div class="col-12 col-md-9">
          <textarea id="message" class="form-control" formControlName="message" rows="4" maxlength="400"></textarea>
          <div class="d-flex justify-content-between mt-1">
            @if (f['message'].invalid && f['message'].touched) {
              <div class="text-danger small">
                {{ 'AtgContactUs.messageRequired' | cxTranslate }}
              </div>
            }
            <div class="text-muted small text-right">{{ f['message'].value?.length || 0 }}/400</div>
          </div>
        </div>
      </div>
      <div class="cx-checkout-btns float-left col-md-12 pb-2 p-0">
        <div class="float-left col-md-3 mb-2 mb-sm-0">&nbsp;</div>
        <div class="float-left col-md-3 mb-2 mb-sm-3 p-0 mr-4">
          <button type="submit" class="btn btn-block btn-primary" [disabled]="contactForm.invalid || isSubmitting">
            @if (isSubmitting) {
              <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
            }
            @if (!isSubmitting) {
              <i class="fas fa-envelope pr-2" aria-hidden="true"></i>
            }
            {{ 'AtgContactUs.email' | cxTranslate }}
          </button>
        </div>
        <div class="float-left col-md-3 mb-2 mb-sm-0 p-0  mr-md-2">
          <button type="button" class="btn btn-block btn-outline-primary background-transparent" (click)="dismiss()">
            {{ 'AtgContactUs.cancel' | cxTranslate }}
          </button>
        </div>
      </div>
      @if (submitError) {
        <div class="float-left col-md-12 p-0 mt-2">
          <div class="alert alert-danger mb-4">{{ 'AtgContactUs.submitError' | cxTranslate }}</div>
        </div>
      }
    </form>
  }
</div>